import React, { useEffect, useRef } from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import classnames from "classnames";
import Logger from "../../../helpers/Logger";
import AvatarView from "../../Common/AvatarView";
import RemoteControlScreenActions from "../../RemoteControl/RemoteControlScreenActions";
import RemoteControlSurface from "../../RemoteControl/RemoteControlSurface";

const logger = new Logger("VideoView");

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: "relative",
      flex: "100 100 auto",
      height: "100%",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
    video: {
      flex: "100 100 auto",
      height: "100%",
      width: "100%",
      borderRadius: 24,
      objectFit: "cover",
      userSelect: "none",
      transitionProperty: "opacity",
      transitionDuration: ".15s",
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      [theme.breakpoints.down("xs")]: {
        borderRadius: 0,
      },
      "&.isMe": {
        transform: "scaleX(-1)",
      },
      "&.hidden": {
        opacity: 0,
        transitionDuration: "0s",
      },
      "&.loading": {
        filter: "blur(5px)",
      },
      "&.contain": {
        objectFit: "contain",
        backgroundColor: "rgb(36, 43, 48)",
      },
    },
    avatarContainer: {
      display: "flex",
      position: "absolute",
      top: 0,
      left: 0,
      bottom: 0,
      right: 0,
      justifyContent: "center",
      alignItems: "center",
    },
    avatar: {
      background: "none",
      fontSize: 32,
      border: "none",
    },
  })
);
const VideoView = ({
  isMe = false,
  peer,
  isScreen = false,
  displayName = "",
  videoContain = false,
  videoVisible = false,
  videoTrack = null,
}) => {
  const classes = useStyles();

  const videoRef = useRef(null);

  //Gerekli olmayabilir ??
  useEffect(() => {
    const videoDom = { ...videoRef.current };
    return () => {
      if (videoDom) {
        videoDom.oncanplay = null;
        videoDom.onplay = null;
        videoDom.onpause = null;
      }
    };
  }, []);

  useEffect(() => {
    if (videoTrack) {
      const stream = new MediaStream();

      stream.addTrack(videoTrack);
      //roomClient.appendRecording(stream);

      videoRef.current.srcObject = stream;

      videoRef.current
        .play()
        .catch((error) =>
          logger.warn('videoRef.current.play() [error:"%o]', error)
        );
    } else {
      videoRef.current.srcObject = null;
    }
  }, [videoTrack]);

  return (
    <div className={classes.root}>
      {!videoVisible && (
        <div className={classes.avatarContainer}>
          <AvatarView
            alt={displayName}
            src={peer?.picture}
            id={peer?.id}
            className={classes.avatar}
            displayName={displayName}
          />
        </div>
      )}
      <video
        ref={videoRef}
        className={classnames(classes.video, {
          hidden: !videoVisible,
          isMe: isMe && !isScreen,
          contain: videoContain,
        })}
        autoPlay
        playsInline
        muted
        controls={false}
      />
      {isScreen && !isMe && peer && peer.id && (
        <>
          <RemoteControlSurface videoRef={videoRef} hostPeerId={peer.id} />
          <RemoteControlScreenActions hostPeerId={peer.id} />
        </>
      )}
    </div>
  );
};

VideoView.propTypes = {
  isMe: PropTypes.bool,
  isScreen: PropTypes.bool,
  peer: PropTypes.object,
  displayName: PropTypes.string,
  videoContain: PropTypes.bool,
  videoTrack: PropTypes.any,
  videoVisible: PropTypes.bool.isRequired,
};

export default VideoView;
